import { useState } from "react";
import { getAxiosInstance } from "../../utils/axiosInstance";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

import {FormControl, FormLabel, Input} from "@chakra-ui/react";
import Modal from "../Modal";

interface NewRoleModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ModalProvider = (props: NewRoleModalProps) => {
  const [provider, setProvider] = useState({});
  const { t } = useTranslation("translations");

  const setUpProviderObject = (value: string, name: string) => {
    setProvider({...provider, [name]: value});
  }

  const addProvider = async () => {
    try {
      const res = await getAxiosInstance().post('/providers', {...provider});
      if (res.status === 200) {
        toast.success("Added Provider successfully", {position: toast.POSITION.BOTTOM_RIGHT});
        setProvider({});
        props.onClose();
      } else {
        toast.error("Something is wrong", {position: toast.POSITION.BOTTOM_RIGHT});
      }
    } catch (error) {
      toast.error("Fields not filled out properly", {position: toast.POSITION.BOTTOM_RIGHT});
    }
  }

  return (
    <>
      <Modal
        header={"Add Provider"}
        isOpen={props.isOpen}
        onClose={props.onClose}
        secondaryActionName={t("Save")}
        secondaryActionEnabled={true}
        secondaryAction={() => addProvider()}
      >
        <div className="space-y-2">
          <FormControl>
            <FormLabel>{t("Name")}</FormLabel>
            <Input
              isRequired
              name='name'
              onChange={(e) => {
                setUpProviderObject(e.target.value, e.target.name)
              }} 
              placeholder='ex: John Doe'
            />
          </FormControl>
          
          <FormControl mt={2}>
            <FormLabel>C.U.I</FormLabel>
            <Input
              isRequired
              name="cui"
              onChange={(e) => {
                setUpProviderObject(e.target.value, e.target.name)
              }} 
              placeholder='ex: RO123456789C'
            />
          </FormControl>
          <FormControl mt={2}>
            <FormLabel>{t("Address")}</FormLabel>
            <Input
              isRequired
              name="address" 
              onChange={(e) => {
                setUpProviderObject(e.target.value, e.target.name)
              }} 
              placeholder='ex: Str Mihai Eminescu nr.19 ap.31'
            />
          </FormControl>
          <FormControl mt={2}>
            <FormLabel> {t("Phone Number")}</FormLabel>
            <Input
              isRequired
              name="phoneNumber"
              onChange={(e) => {
                setUpProviderObject(e.target.value, e.target.name)
              }} 
              placeholder='ex: +40745555555'
            />
          </FormControl>
          <FormControl mt={2}>
            <FormLabel> {t("Email")}</FormLabel>
            <Input
              isRequired
              name="email"
              type="email"
              onChange={(e) => {
                setUpProviderObject(e.target.value, e.target.name)
              }} 
              placeholder='ex: example@gmail.con' 
              size='md'
            />
          </FormControl>
          <FormControl mt={2}>
            <FormLabel> {t("Country")}</FormLabel>
            <Input
              isRequired
              name="country"
              onChange={(e) => {
                setUpProviderObject(e.target.value, e.target.name)
              }} 
              placeholder='ROMANIA'
            />
          </FormControl>
        </div>
      </Modal>

    </>
  )
}


export default ModalProvider;